import { ListItem, MenuItem, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  CoordinateSelector,
  getLocationCoords,
} from 'components/CoordinateSelector';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { useShareOrCopy } from 'hooks/useShareOrCopy';
import { parseCoordinate } from 'shared/utils';
import { useCoordinateFormatState } from 'state/useCoordinateFormatState';
import { MapToolsMenuItemProps } from './types';

export const CopyPositionMenuItem = (
  props: MapToolsMenuItemProps,
): JSX.Element => {
  const { position, onClick, padding, variant } = props;
  const { t } = useTranslation();
  const { copied, shareOrCopyText, reset } = useShareOrCopy();
  const { coordinateFormat } = useCoordinateFormatState();
  const pinImprovements = useReleaseFlag('pin_drop_improvements');
  const latLng = pinImprovements
    ? getLocationCoords({
        lat: position.lat,
        lng: position.lng,
        format: coordinateFormat,
      })
    : `${parseCoordinate(position.lat)}, ${parseCoordinate(position.lng)}`;

  if (pinImprovements && variant === 'drawer') {
    return (
      <ListItem disablePadding sx={{ display: 'block' }}>
        <CoordinateSelector
          coordinates={position}
          sx={{ bgcolor: 'transparent' }}
        />
      </ListItem>
    );
  }

  return (
    <Tooltip
      title={t('common.copied')}
      open={copied}
      placement="top"
      onClose={reset}
      leaveDelay={200}
    >
      <MenuItem
        onClick={() => {
          shareOrCopyText({ text: latLng, showClipboardSuccessMessage: false });
          // Give the tooltip a little time to show up before closing the context menu.
          setTimeout(onClick, 500);
        }}
        sx={{ padding }}
      >
        {latLng}
      </MenuItem>
    </Tooltip>
  );
};
